import React, { FC, useEffect, useState, useContext } from 'react'
import CryptoJS from 'crypto-js'
import { useDispatch, useSelector } from 'react-redux'
import usePrevious from '../../hooks/usePrevious'
import { useHistory } from 'react-router-dom'
import isAuthenticated from '../../routes/isAuthenticated'
import { AbilityContext } from '../../config/Can'
import { AppAbility } from '../../config/ability'
import { Alert, Card, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CircularProgress from '@material-ui/core/CircularProgress'
import BootstrapTable from 'react-bootstrap-table-next'
import moment from 'moment'
import { addUserActivity } from '../../redux/actions/authentication'
import { getAnnouncement, getNewsAndUpdates, getNewsAndUpdatesByOrganization } from '../../redux/actions/newsUpdate'
import RootState from '../../types/RootState'
import NewsModal from '../../components/Modals/NewsModal'
import { formatUTCDate } from '../../utils/stringTools'
import { getDomainName } from '../../utils/envVariables'
import './index.css'

interface Props {
  height: number;
  width: number;
}

const NewsUpdates: FC<Props> = ({ height, width }: Props) => {
  const [show, setShow] = useState(false)
  const [showAlert, setShowAlert] = useState(false)
  const [newsItem, setNewsItem] = useState(null)

  const history = useHistory()
  const dispatch = useDispatch()
  const domainName = getDomainName()
  const ability: AppAbility = useContext(AbilityContext)
  const emailKey = 'lakelandproviderportalinsertuserencryption'
  const token = localStorage.getItem('token')!== null && localStorage.getItem('token')!=='undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''

  const { getAnnouncementData, announcement, announcementResult, newsAndUpdates, organizationView, selectedOrganization, selectedProvider, user } = useSelector((state: RootState) => ({
    getAnnouncementData: state.newsUpdates.announcement,
    announcement: state.newsUpdates.announcement.data,
    announcementResult: state.newsUpdates.announcement,
    newsAndUpdates: state.newsUpdates.newsAndUpdates.data,
    organizationView: state.authentication.organizationView,
    selectedOrganization: state.authentication.selectedOrganization,
    selectedProvider: state.authentication.selectedProvider,
    user: state.authentication.user.data
  }))

  useEffect(() => {
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')

    if(token !== ''){
      dispatch(getAnnouncement(token))

      if( !organizationView && selectedProvider.provider_id !== -1 ) {
        dispatch(getNewsAndUpdates(selectedProvider.provider_id, token))
      }
      if( organizationView && selectedOrganization.organization_id !== -1 ) {
        dispatch(getNewsAndUpdatesByOrganization(selectedOrganization.organization_id, token))
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const prevSelectedOrganization = usePrevious(selectedOrganization)
  useEffect(() => {
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    if(organizationView && selectedOrganization !== prevSelectedOrganization && selectedOrganization.organization_id !== -1 && token !== ''){
      dispatch(getAnnouncement(token))
      dispatch(getNewsAndUpdatesByOrganization(selectedOrganization.organization_id, token))
      dispatch(addUserActivity({
        eid: email.eid,
        activity: 'View News and Updates',
        organizationId: selectedOrganization.organization_id
      }, token))
    }
  }, [selectedOrganization]) // eslint-disable-line react-hooks/exhaustive-deps

  const prevSelectedProvider = usePrevious(selectedProvider)
  useEffect(() => {
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid')|| '{}')
    if (!organizationView && selectedProvider !== prevSelectedProvider && selectedProvider.provider_id !== -1 && token !== '') {
      dispatch(getNewsAndUpdates(selectedProvider.provider_id, token))
      dispatch(addUserActivity({
        eid: email.eid,
        activity: 'View News and Updates',
        providerId: selectedProvider.provider_id
      }, token))
    }
  }, [selectedProvider]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if(getAnnouncementData.success && !getAnnouncementData.error){
      setShowAlert(true)
    }
  }, [getAnnouncementData])

  // Check if user can View this route
  useEffect(() => {
    if (ability.can('View', 'ApplicationProcess')) {
      history.push('/applicant')
    }
  }, [ability]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleModal = () => {
    setShow(!show)
  }

  const handleRowClick = (e: any, row: any) => {
    setShow(true)
    setNewsItem(row)
  }

  const diff = moment.utc().diff(moment.utc(newsAndUpdates[0] ? newsAndUpdates[0].date : undefined), 'days')
  let updatedString

  if (diff === 1) {
    updatedString = `${diff} day ago on ${newsAndUpdates[0] ? formatUTCDate(newsAndUpdates[0].date) : ''}`
  } else {
    updatedString = `${diff} days ago on ${newsAndUpdates[0] ? formatUTCDate(newsAndUpdates[0].date) : ''}`
  }

  const columns = [{
    dataField: 'date',
    text: 'Date',
    sort: true,
    formatter: formatUTCDate,
    headerStyle: {
      width: 200
    }
  }, {
    dataField: 'content',
    text: 'Message',
    sort: true
  }, {
    dataField: 'attachment',
    text: 'Attachment',
    sort: true,
    formatter: (cell) => {
      if (cell !== '' && cell !== null) {
        let content = cell.split('/')
        return (
          <Link
            to="route"
            onClick={(event) => { event.preventDefault(); window.open(domainName+'/pdf/news/'+content[content.length-1]) }}
          >
            {content[content.length-1]}
          </Link>
        )
      }
      return 'N/A'
    },
    headerStyle: {
      width: 200
    }
  }
  ]

  let announcementDate = moment(announcement.entered_date).format('MM/DD/YYYY')

  const handleRowEvents = {
    onClick: handleRowClick
  }

  let data =  <div>No News available</div>

  if(announcementResult.loading===true)
    data = (
      <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px'}}>
        <CircularProgress size={40} />
        <span>Loading data</span>
      </div>
    )

  if ((user && !user.user_id) || ability.rules.length === 0) return null

  return (
    <Container 
      style={{
        paddingTop:20, 
        paddingLeft: 0,
        backgroundColor: '#f5f5f5', 
        width:width, 
        height:height-20, 
        maxWidth:width, 
        overflow:'auto'
      }}
    >
      <Row>
        <div className="news-header">
          <div className="news-header-txt">
            <div className="news-icon">
              <FontAwesomeIcon icon={['fas', 'info-circle']} size="3x" />
            </div>
            <div>
              <div className="news-container">
                <h3>News & Updates</h3>
              </div>
              <div className="news-data">
                <div>Last Updated: { updatedString } </div>
              </div>
            </div>
          </div>
        </div>
      </Row>
      <Card style={{ border: 'none', width: width - 15, height: height - 120 }}>
        <Card.Body>
          {
            showAlert?(
              <Alert variant="info" onClose={() => setShowAlert(false)} dismissible>
                <Alert.Heading className='news-alert-heading'>{announcement.title}<span className='announcement-entered-date'>{announcementDate}</span></Alert.Heading>
                <p className='news-alert-content' style={{ textAlign: 'center' }}>{announcement.content}</p>
              </Alert>
            ):(
              <div></div>
            )
          }
          <div style={{ marginTop: 10 }}>
            <BootstrapTable
              keyField='id'
              bootstrap4
              data={newsAndUpdates}
              columns={columns}
              rowEvents={handleRowEvents}
              striped
              condensed
              hover
              noDataIndication={() => (data)}
            />
          </div>
        </Card.Body>
      </Card>
      <NewsModal show={show} onClose={handleModal} newsItem={newsItem} />
    </Container>
  )
}

export default isAuthenticated(NewsUpdates)